import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './components/Dashboard';
import Users from './pages/Users';
import Leaders from './pages/Leaders';
import LeaderUploads from './pages/LeaderUploads';
import LeaderMemberDetails from './pages/LeaderMemberDetails';
import Stickers from './pages/Stickers';
import HelpVideos from './pages/HelpVideos';
import Uploads from './pages/Uploads';
import Banners from './pages/Banners';
import PreviewPage from './pages/PreviewPage';
import UserProfile from './pages/UserProfile';
import CustomFramePage from './pages/CustomFramePage';
import CustomVideoFramePage from './pages/CustomVideoFramePage';
import DefaultFrames from './pages/DefaultFrames';
import Subscriptions from './pages/Subscriptions';
import Login from './pages/Login';
import Birthdays from './pages/Birthdays';
import Partners from './pages/Partners';
import Settings from './pages/Settings';
import LandingPage from './pages/LandingPage';
import { isTokenValid } from './utils/auth';
import './App.css';

function AppContent() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(isTokenValid());

  // Check token validity periodically and on mount
  useEffect(() => {
    const checkAuth = () => {
      const valid = isTokenValid();
      if (!valid && isAuthenticated) {

        setIsAuthenticated(false);
        navigate('/login', { replace: true });
      } else if (valid !== isAuthenticated) {
        setIsAuthenticated(valid);
      }
    };

    // Check immediately
    checkAuth();

    // Check every 30 seconds
    const interval = setInterval(checkAuth, 30000);

    return () => clearInterval(interval);
  }, [isAuthenticated, navigate]);

  return (
    <Routes>
      {/* Landing Page Route */}
      <Route path="/" element={<LandingPage />} />

      {/* Admin Routes */}
      <Route path="/admin/login" element={
        isAuthenticated ? <Navigate to="/admin/dashboard" replace /> : <Login />
      } />
      <Route path="/admin" element={
        <Navigate to={isAuthenticated ? "/admin/dashboard" : "/admin/login"} replace />
      } />
      <Route path="/admin/*" element={
        <ProtectedRoute>
          <Layout>
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/users" element={<Users />} />
              <Route path="/birthdays" element={<Birthdays />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/birthdays/:phoneNumber" element={<Birthdays />} />
              <Route path="/subscriptions" element={<Subscriptions />} />
              <Route path="/leaders" element={<Leaders />} />
              <Route path="/leader-uploads/:id" element={<LeaderUploads />} />
              <Route path="/leader-members/:leaderId" element={<LeaderMemberDetails />} />
              <Route path="/stickers" element={<Stickers />} />
              <Route path="/help-videos" element={<HelpVideos />} />
              <Route path="/uploads" element={<Uploads />} />
              <Route path="/banners" element={<Banners />} />
              <Route path="/default-frames" element={<DefaultFrames />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/preview/:type/:id" element={<PreviewPage />} />
              <Route path="/user-profile/:phoneNumber" element={<UserProfile />} />
              <Route path="/custom-frame/:phoneNumber" element={<CustomFramePage />} />
              <Route path="/custom-video-frame/:phoneNumber" element={<CustomVideoFramePage />} />
            </Routes>
          </Layout>
        </ProtectedRoute>
      } />

      {/* Redirect old admin routes */}
      <Route path="/login" element={<Navigate to="/admin/login" replace />} />
      <Route path="/dashboard" element={<Navigate to="/admin/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
